import cn from 'classnames/bind'

import useFromTo from 'app/common/hooks/useFromTo'
import Sticky from 'app/common/templates-next/sticky'
import * as dateTypes from 'app/common/constants/dateTypes'
import SimpleDate from 'app/common/classes/simple-date'
import PlainDateMonthSwitcher from 'app/common/ui-next/plain-date-month-picker'
import PlainDateSwitcher from 'app/common/ui-next/plain-date-switcher'

import CafeteriaSubsidiesData from '../CafeteriaSubsidiesData'
import CafeteriaSubsidiesTable from './CafeteriaSubsidiesTable'
import SubsidiesHeaderBar from './SubsidiesHeaderBar'
import styles from './CafeteriaSubsidies.module.scss';

const cx = cn.bind(styles)

type Props = {
  date: SimpleDate
  dateType: 'day' | 'month'
  header?: string
  school: {
    id: string
    title: string
    isCamp?: boolean
  }
  person: {
    id: number
    name: {
      first: string
      last: string
      middle: string
      gender: 'male' | 'female' | 'androgynous'
    }
    timezone: string
  }
  onChangeDate: (date: string, dateFormat: string, daily?: boolean) => void
}

/**
 *   Компонент столовой "Дотации"
 */

const CafeteriaSubsidies = ({
  date,
  dateType: dt,
  header = 'Дотации',
  school,
  person: { id: personId, timezone },
  onChangeDate,
}: Props) => {
  const dateString = date.getStringFormatted(dt === 'day' ? 'YYYY-MM-DD' : 'YYYY-MM')
  const dateType = dt === 'day' ? dateTypes.DAYS : dateTypes.MONTHS // length(split('-', date)) // 2 - мясяцы, 3 - дни

  const [from, to] = useFromTo({ date: dateString, dateType })

  const { id: schoolId, isCamp } = school

  return (
    <CafeteriaSubsidiesData
      personId={personId}
      timezone={timezone}
      from={from}
      to={to}
      schoolId={isCamp ? schoolId : undefined}
    >
      <Sticky>
        {(ref, sticky) => (
          <SubsidiesHeaderBar
            reference={ref}
            className={cx({ sticky })}
            header={header || 'Дотации'}
          >
            <PlainDateSwitcher
              className={styles.dateSwitcher}
              date={dateString}
              dateFormat={dateType === dateTypes.MONTHS ? 'YYYY-MM' : 'YYYY-MM-DD'}
              displayDateFormat={dateType === dateTypes.MONTHS ? 'MMMM' : undefined}
              stepType={dt}
              onDateChange={onChangeDate}
            >
              <PlainDateMonthSwitcher
                date={dateString}
                dateFormat={dateType === dateTypes.MONTHS ? 'YYYY-MM' : 'YYYY-MM-DD'}
                onChangeDate={onChangeDate}
                hideDateMonthSwitcher
                monthsAmount={24}
              />
            </PlainDateSwitcher>
          </SubsidiesHeaderBar>
        )}
      </Sticky>
      <CafeteriaSubsidiesTable
        date={dateString}
        personId={personId}
        timezone={timezone}
        schoolId={isCamp ? schoolId : undefined}
      />
    </CafeteriaSubsidiesData>
  )
}

export default CafeteriaSubsidies
